/* eslint-disable */
import { JsonObject, JsonProperty } from "typescript-json-serializer";
import {PortalItemConfiguration} from "../core/config/portal-item-configuration";
import {LayerObjectType} from "../stores/layer-object-type";


@JsonObject()
export class AuftragsverwaltungApiXhrConfiguration {
    @JsonProperty()
    declare usePost: boolean;
    @JsonProperty()
    declare useProxy?: boolean;
    @JsonProperty()
    declare timeout?: number;
    @JsonProperty()
    declare responseType?: "json" | "xml" | "text" | "blob" | "array-buffer" | "document" | "image";

    constructor() {}
}


@JsonObject()
export class ApiLayerConfiguration {

    @JsonProperty()
    declare objectType: "project" | "municipality" | "process-source" | "partial-order-ghk" | "partial-order-gk"|
    "process-log" | "contractor" | "perimeter-ghk" | "perimeter-gk" | "document";

    @JsonProperty()
    declare portalItem: PortalItemConfiguration;

    @JsonProperty()
    declare layerId: number;

    @JsonProperty()
    declare errorMessage: string;

    @JsonProperty()
    declare notFoundMessage: string;

    /**
     * If to filter when project is selected
     */
    @JsonProperty()
    declare projectFilter: boolean;

    /**
     * The topics this API layer belongs to
     */
    @JsonProperty()
    declare topicIds: string[];

    /**
     * Default sort order
     */
    initalSort: string;

    constructor() {}
}

@JsonObject()
export class AuftragsverwaltungApiConfiguration {
    @JsonProperty()
    declare xhrOptions: AuftragsverwaltungApiXhrConfiguration;

    @JsonProperty()
    declare layers: ApiLayerConfiguration[];

    constructor() {}

    getLayerConfig(objectType: LayerObjectType): ApiLayerConfiguration | undefined {
        return this.layers.find((layer: ApiLayerConfiguration) => layer.objectType === objectType);
    }

    getLayerConfigByPortalId(portalItemId: string, layerId: number): ApiLayerConfiguration | undefined {
        return this.layers.find((layerConfig: ApiLayerConfiguration) => {
            return layerConfig.portalItem?.id === portalItemId &&
                layerConfig.layerId === layerId;
        });
    }
}
